import { useState } from "react";
import {
  Box,
  Step,
  StepLabel,
  Stepper,
  SxProps,
  Typography,
} from "@mui/material";
import GeneralAndSiteInfo from "./Steps/GeneralAndSiteInfo";
import Features from "./Steps/Features";
import Settings from "./Steps/Settings";
import { DrawerHeader } from "../Common/styles/drawer";
import { useTranslation } from "react-i18next";

type Props = {
  closeDrawer: () => void;
  refreshPage: () => void;
};

const CustomStepWrapper: SxProps = {
  mb: 3,
  "& .MuiStepConnector-root": {
    display: "none",
  },
  "& .MuiStep-root": {
    width: "33.33%",
  },
};

const CustomStepStyle: SxProps = {
  "& .MuiSvgIcon-root.Mui-completed": {
    color: "#70AE71",
  },
  "& .MuiSvgIcon-root.Mui-active": {
    color: "primary.main",
  },
  "& .MuiStepIcon-root": {
    height: "34px",
    width: "34px",
  },
  "& .MuiStepLabel-label": {
    typography: "h3",
    fontWeight: "regular",
  },
};

const STUDY_STEP_KEYS = [
  "ADD_STUDY_DRAWER.STEP_GENERAL_AND_SITE",
  "ADD_STUDY_DRAWER.STEP_FEATURES",
  "ADD_STUDY_DRAWER.STEP_SETTINGS",
];

const AddStudyDetailDrawer = ({ closeDrawer, refreshPage }: Props) => {
  const { t } = useTranslation("studies");
  const [activeStep, setActiveStep] = useState<number>(0);
  const [studyId, setStudyId] = useState<string>("");

  const handleNext = () => {
    setActiveStep((prevActiveStep) => prevActiveStep + 1);
  };
  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };
  return (
    <Box
      sx={{
        width: "900px",
        p: 2.5,
      }}
    >
      <DrawerHeader title={t("ADD_STUDY_DRAWER.TITLE")} closeDrawer={closeDrawer} />
      <Box
        sx={{
          width: "100%",
        }}
      >
        <Stepper activeStep={activeStep} sx={CustomStepWrapper}>
          {STUDY_STEP_KEYS.map((labelKey, index) => {
            const stepProps: { completed?: boolean } = {};
            const labelProps: {
              optional?: React.ReactNode;
            } = {};
            return (
              <Step key={labelKey} {...stepProps} sx={CustomStepStyle}>
                <StepLabel {...labelProps}>
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                    }}
                  >
                    <Typography variant="subtitle1" color="text.secondary">
                      {t("ADD_STUDY_DRAWER.STEP_LABEL", { number: index + 1 })}
                    </Typography>
                    <Typography
                      variant="h3"
                      fontWeight="regular"
                      color="text.primary"
                    >
                      {t(labelKey)}
                    </Typography>
                  </Box>
                </StepLabel>
              </Step>
            );
          })}
        </Stepper>
        <Box
          sx={{
            p: activeStep === 2 ? 0 : 3,
            overflow: "auto",
            height: "calc(100vh - 210px)",
          }}
        >
          {activeStep === 0 && (
            <GeneralAndSiteInfo
              handleNext={handleNext}
              setStudyId={setStudyId}
            />
          )}
          {activeStep === 1 && (
            <Features
              handleBack={handleBack}
              studyId={studyId}
              refreshPage={refreshPage}
              closeDrawer={closeDrawer}
              handleNext={handleNext}
            />
          )}
          {activeStep === 2 && (
            <Settings
              refreshPage={refreshPage}
              closeDrawer={closeDrawer}
              studyId={studyId}
            />
          )}
        </Box>
      </Box>
    </Box>
  );
};

export default AddStudyDetailDrawer;
